import strap from '@/components/parts/Strap';
import watchCase from '@/components/parts/Case';
import crown from '@/components/parts/Crown';
import pusher from '@/components/parts/Pusher';
import calendar from '@/components/parts/Calendar';
import dial from '@/components/parts/Dial';
import hand from '@/components/parts/Hand';

export default {
  strap,
  watchCase,
  calendar,
  crown,
  pusher,
  dial,
  hand,
};
